// extracted by mini-css-extract-plugin
module.exports = {"Testimonials":"Testimonials_Testimonials__fGOuv","background":"Testimonials_background__3cjJh","centered":"Testimonials_centered__1V3tj"};